import React from 'react';
import PropTypes from 'prop-types';
import RainMan from '../../components/Animations/RainMan';
import history from '../../core/history';
import { isProd, SENTRY_DSN, isDev } from '../../config';
import { isClientSide } from '../../core/util/system';
import styled, { createGlobalStyle } from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily } from '../../constants/text';
import { biggerThanOrEqualTo } from '../../core/util/styledComponents';
import { analyticsTagHotjarRecording, analyticsTrackEvent } from '../../core/analytics';
import { ERROR_PAGE_RELOAD } from '../../core/analytics/events';
import logger from '../../core/logger';
import { HOTJAR_TRACKING_LABEL } from '../../core/tracking/hotjar/constants';
const Raven = isClientSide() ? require('raven-js') : null;

const Root = styled.div`
  box-sizing: border-box;
  padding: 10vh 5vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  ${biggerThanOrEqualTo.tablet`
    padding: 20vh 10vw;
  `} * {
    margin: 0 auto;
  }

  a {
    cursor: pointer;
  }

  pre {
    text-align: left;
    margin-top: 2rem;
  }
`;

const GlobalStyles = createGlobalStyle`
  #app {
    height: 100%;
  }
`;

const Title = styled.div`
  font-family: ${fontFamily.medium};
  font-size: 2em;
  color: ${colors.crunchBerry};
  text-align: center;
`;

const ErrorContent = styled.div`
  font-size: 1em;
  color: ${colors.blueMonday};
  text-align: center;
`;

const reloadPage = () => {
  analyticsTrackEvent(ERROR_PAGE_RELOAD);
  window.location.reload(true);
};

const ErrorPage = ({ error = {} }) => {
  if (error && error.status === 404) {
    history.replace('/404');
    return null;
  }

  if (error && SENTRY_DSN && Raven) {
    logger.debug(error);
    Raven.captureException(error);
    analyticsTagHotjarRecording([HOTJAR_TRACKING_LABEL.errorPage]);
  }

  return (
    <Root>
      <GlobalStyles />
      <Title>We're a little under the weather</Title>
      <RainMan />
      <ErrorContent>
        Please <a onClick={reloadPage}>refresh</a> or try back soon.
        <br />
        Still not working? <a href="mailto:info@solvhealth.com">Contact us</a>.
      </ErrorContent>
    </Root>
  );
};

ErrorPage.propTypes = { error: PropTypes.object };

export default ErrorPage;
